(function () {
  var STORAGE_KEY = "tp_color_expanded";

  function getExpanded() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function setExpanded(isExpanded) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, isExpanded ? "1" : "0");
    } catch (e) {}
  }

  function syncButton(btn, collapsed) {
    btn.setAttribute("aria-expanded", collapsed ? "false" : "true");

    var labelCollapsed = btn.getAttribute("data-tp-label-collapsed") || "Prikaži sve boje";
    var labelExpanded = btn.getAttribute("data-tp-label-expanded") || "Sakrij boje";

    btn.textContent = collapsed ? labelCollapsed : labelExpanded;
  }

  function applyState(root) {
    (root || document).querySelectorAll(".tp-color-fieldset").forEach(function (fieldset) {
      var btn = fieldset.querySelector(".tp-color-toggle");
      if (!btn) return;

      var expanded = getExpanded();
      fieldset.setAttribute("data-tp-collapsed", expanded ? "false" : "true");
      syncButton(btn, !expanded);
    });
  }

  function toggle(btn) {
    var fieldset = btn.closest(".tp-color-fieldset");
    if (!fieldset) return;

    var collapsed = fieldset.getAttribute("data-tp-collapsed") !== "false";
    var nextCollapsed = !collapsed;

    fieldset.setAttribute("data-tp-collapsed", nextCollapsed ? "true" : "false");
    syncButton(btn, nextCollapsed);

    // Save preference
    setExpanded(!nextCollapsed);
  }

  // Click handler (survives Dawn re-render)
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".tp-color-toggle");
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  // Initial apply
  document.addEventListener("DOMContentLoaded", function () {
    applyState(document);
  });

  // Re-apply after Dawn swaps product-info HTML
  // We observe DOM changes and re-apply when new fieldset appears
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.addedNodes && m.addedNodes.length) {
        // cheap check: if color fieldset or toggle appears, apply
        var shouldApply = false;
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && (node.matches(".tp-color-fieldset") || node.querySelector(".tp-color-fieldset"))) {
            shouldApply = true;
          }
        });
        if (shouldApply) {
          applyState(document);
          break;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
// --- TP: move "Show all colors" toggle BELOW the swatch grid (PDP) ---
document.addEventListener('DOMContentLoaded', () => {
  // pokušaj više puta jer se neki elementi ubacuju malo kasnije
  let tries = 0;
  const maxTries = 20;

  const tick = () => {
    tries += 1;

    const fieldset = document.querySelector('.tp-color-fieldset');
    if (!fieldset) return tries < maxTries ? setTimeout(tick, 100) : null;

    const grid = fieldset.querySelector('.tp-color-grid');
    const toggle = fieldset.querySelector('.tp-color-toggle');
    if (!grid || !toggle) return tries < maxTries ? setTimeout(tick, 100) : null;

    // ako je toggle već ispod, ne diramo
    if (toggle.previousElementSibling === grid) return;

    // premesti toggle odmah posle grida
    grid.insertAdjacentElement('afterend', toggle);
  };

  tick();
});